/* @ngInject */
export default class AdminUserProjectsController {
  constructor(user, permissions) {
    this.user = user;
    this.permissions = permissions;
  }
}
